import * as React from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { FaCut, FaSpa, FaPaintBrush, FaHandSparkles, FaFemale, FaPlus, FaEye, FaAppleAlt } from 'react-icons/fa';
import { useLocation } from 'react-router-dom';
import nails from '../../../assets/nails.jpg';
import pedicure from '../../../assets/pedicure.jpg';
import facialTreatments from '../../../assets/facialTreatments.jpg';
import bodyRelaxation from '../../../assets/bodyRelaxation.jpg';
import hairCutStyle from '../../../assets/hairCutStyle.jpg';
import hairColoringTechnicalServices from '../../../assets/hairColoringTechnicalServices.jpg';
import waxing from '../../../assets/waxing.jpg';
import makeUp from '../../../assets/makeUp.jpg';
import specializedAppointments from '../../../assets/specializedAppointments.jpg';
import traditionalChineseMedicine from '../../../assets/traditionalChineseMedicine.jpg';


// Define structure for individual services
interface ServiceItem {
  name: string;
  price?: string | number; // Price can be a string (like '€X') or number
  options?: ServiceItem[]; // For nested options like Hair Brushing or Waxing
}

// Define structure for service categories
interface ServiceCategory {
  id: number;
  title: string;
  icon: React.ReactNode;
  services: ServiceItem[];
  image: string;
}

// New categorized service data
const servicesData: ServiceCategory[] = [
  {
    id: 1,
    title: 'Nails',
    icon: <FaHandSparkles className="text-2xl mr-3" />,
    image: nails,
    services: [
      { name: 'Pintura de unhas com verniz normal', price: '€6' },
      { name: 'Manicure Verniz Normal', price: '€10' },
      { name: 'Manicure infantil (até 8 anos)', price: '€8' },
      { name: 'Manicure Verniz de Gel', price: '€17' },
      { name: 'Colocação de verniz gel', price: '€11' },
      { name: 'Manicure Manutenção Gel', price: '€26' },
      { name: 'Manicure Gel com Extenção', price: '€36' },
      { name: 'Remoção de verniz de gel' }, // No price listed
    ],
  },
  {
    id: 2,
    title: 'Pedicure',
    icon: <FaSpa className="text-2xl mr-3" />, // Changed icon
    image: pedicure,
    services: [
      { name: 'Pintura de unhas com verniz normal', price: '€7' },
      { name: 'Corte de unhas', price: '€11' },
      { name: 'Pedicure', price: '€21' },
      { name: 'Pedicure com calosidades', price: '€23' },
      { name: 'Pedicure com Verniz Gel', price: '€29' },
      { name: 'Pedicure Calosidades com Verniz Gel', price: '€31' },
      { name: 'Colocação verniz de gel', price: '€12' },
    ],
  },
  {
    id: 3,
    title: 'Facial Treatments',
    icon: <FaEye className="text-2xl mr-3" />, // Changed icon
    image: facialTreatments,
    services: [
      { name: 'Limpeza Pele Rosto', price: '€45' },
      { name: 'Limpeza Pele das Costas', price: '€60' },
    ],
  },
  {
    id: 4,
    title: 'Body Relaxation',
    icon: <FaSpa className="text-2xl mr-3" />,
    image: bodyRelaxation,
    services: [
      { name: 'Massagem Relax - Corpo Inteiro', price: '€42' },
      { name: 'Massagem Relax - Costas', price: '€32' },
      { name: 'Drenagem linfática manual - corpo inteiro', price: '€42' },
      { name: 'Drenagem linfática manual - localizada', price: '€35' },
      { name: 'Massagem com velas quentes', price: '€50' },
      { name: 'Serviço Livre Estética', price: '(customized with the technician)' },
    ],
  },
   {
    id: 5,
    title: 'Hair - Cut & Style',
    icon: <FaCut className="text-2xl mr-3" />,
    image: hairCutStyle,
    services: [
      { name: 'Serviço Livre Hair', price: '(customized with the technician)' },
      { name: 'Pré-secagem', price: '€7' },
      { name: 'Brushing', options: [
          { name: 'Cabelos Curtos' }, // Price might vary, indicate customization or base price
          { name: 'Cabelos Médios' },
          { name: 'Cabelos Longos' },
          { name: 'Cabelos Extra Longos' },
        ] },
      { name: 'Corte Senhora' }, // Price might vary
      { name: 'Corte Franja', price: '€7' },
      { name: 'Corte Parcial', price: '€9' },
      { name: 'Corte Criança (até 9 anos)', price: '€10' },
      { name: 'Corte Homem', price: '€12' },
    ],
  },
  {
    id: 6,
    title: 'Hair - Coloring & Technical Services',
    icon: <FaPaintBrush className="text-2xl mr-3" />,
    image: hairColoringTechnicalServices,
    services: [
      { name: 'Serviço Livre Técnicos', price: '(customized with the technician)' },
      { name: 'Escova Progressiva', options: [
          { name: 'Cab. Curtos', price: '€70' },
          { name: 'Médios', price: '€120' },
          { name: 'Longos', price: '€140' },
          { name: 'Extra-Longos', price: '€170' },
        ] },
      { name: 'Coloração Raiz', price: '€35' },
      { name: 'Coloração Total' }, // Price might vary
      { name: 'Madeixas/Nuances + Brushing' }, // Price might vary
      { name: 'Madeixas/Nuances + Corte + Brushing' }, // Price might vary
      { name: 'Hidratação profunda Cotry', price: '€50' },
      { name: 'Botox capilar Cotry (brushing included)', price: '€70' },
    ],
  },
  {
    id: 7,
    title: 'Waxing',
    icon: <FaFemale className="text-2xl mr-3" />, // Using FaFemale for waxing
    image: waxing,
    services: [
      { name: 'Buço', price: '€5.5' },
      { name: 'Sobrancelhas', price: '€6' },
      { name: 'Zonas pequenas do rosto', price: '€9' },
      { name: 'Axilas', price: '€8' },
      { name: 'Braços', price: '€13' },
      { name: 'Costas', price: '€11' },
      { name: 'Barriga', price: '€11' },
      { name: 'Peito', price: '€10' },
      { name: '1/2 Perna Inferior', price: '€16' },
      { name: '1/2 Perna Superior', price: '€17' },
      { name: 'Perna Inteira', options: [
          { name: 's/ Virilhas', price: '€20' },
          { name: 'Virilha Normal', price: '€24' },
          { name: 'Virilha Cavada', price: '€26' },
          { name: 'Virilha Total', price: '€29' },
          { name: 'Total + Nádegas', price: '€33' }
        ]},
      { name: 'Virilha Normal', price: '€10' },
      { name: 'Virilha Cavada', price: '€12' },
      { name: 'Virilha Total', price: '€15' },
      { name: 'Nádegas', price: '€9' },
    ],
  },
  {
    id: 8,
    title: 'Make-Up',
    icon: <FaPaintBrush className="text-2xl mr-3" />, // Reusing paint brush
    image: makeUp,
    services: [
        { name: 'Make-Up', price: '(customized with the technician) €20' }, // Clarified custom price
    ],
  },
  {
    id: 9,
    title: 'Specialized Appointments',
    icon: <FaPlus className="text-2xl mr-3" />, // Plus icon for specialized/custom
    image: specializedAppointments,
     services: [
        { name: 'Agendamento personalizado', price: '(booked by the professional)' },
    ],
  },
  {
    id: 10,
    title: 'Traditional Chinese Medicine',
    icon: <FaAppleAlt className="text-2xl mr-3" />, // Apple for health/wellness
    image: traditionalChineseMedicine,
    services: [
      { name: 'Acupuncture (accompaniment)', price: '€35' },
      { name: 'Acupuncture (first consultation with treatment)', price: '€45' },
      { name: 'Therapeutic massage Tuína', price: '€50' },
      { name: 'Post-surgical lymphatic drainage', price: '(by professional advice) €45' }, // Clarified custom price
    ],
  },
];


const ServicesPage: React.FC = () => {
  const location = useLocation();
  const serviceID = location.state?.serviceID; // Using optional chaining ?. in case state is null
  const [activeCategoryId, setActiveCategoryId] = React.useState<number | null>(serviceID || null); // Allow null to have none open initially
  const [backgroundImage, setBackgroundImage] = React.useState<string | null>(nails);
  const containerVariants = {
    visible: {
      transition: {
        staggerChildren: 0.1, // Faster stagger for potentially longer list
      },
    },
  };
  

  const itemVariants = {
    hidden: { opacity: 0, y: 20 },
    visible: { opacity: 1, y: 0 },
  };

  const toggleAccordion = (id: number) => {
    const currentlyActiveId = activeCategoryId; // Store the current ID
    const activeCategory = servicesData.find(category => category.id === id);
    const backgroundImage = activeCategory ? activeCategory.image : null; // Use null or a default image path if desired
    setBackgroundImage(backgroundImage);
    if (currentlyActiveId === id) {
      // If clicking the already open one, just close it
      setActiveCategoryId(null);
    } else if (currentlyActiveId !== null) {
      // If clicking a different one AND another was open, close current, wait, then open new one
      setActiveCategoryId(null);
      setTimeout(() => {
        setActiveCategoryId(id);
      }, 300); // Delay only when switching from an open item
    } else {
      // If clicking one and none were open, open it immediately
      setActiveCategoryId(id);
    }
  };


  // Style object for the background
  const sectionStyle: React.CSSProperties = {
    backgroundImage: backgroundImage
      ? `url(${backgroundImage})` // Added overlay
      : 'none', // Default background or none
    backgroundSize: 'cover',
    backgroundPosition: 'center',
  };

  return (
    <motion.section
      className="py-24 transition-all duration-500 ease-in-out" // Removed bg-gray-50
      style={sectionStyle} // Apply dynamic background style
      initial="hidden"
      animate="visible"
      variants={containerVariants}
    >
      <div className="container mx-auto px-4 py-10">

        {/* Removed the flex layout and image section */}
        <div className="mx-auto flex gap-6 justify-center w-full max-w-3xl"> {/* Centered the accordion */}
          <div className="space-y-4 w-full">
            {servicesData.map((category) => (
              <motion.div
                key={category.id}
                className="bg-white rounded-lg shadow-md overflow-hidden"
                variants={itemVariants}
                layout // Added layout animation for smoother opening/closing
              >
                <button
                  className="w-full p-5 flex justify-between items-center text-left hover:bg-gray-100 transition-colors duration-200" // Added hover effect
                  onClick={() => toggleAccordion(category.id)}
                >
                  <div className="flex items-center">
                    {category.icon}
                    <h3 className="text-xl font-semibold text-gray-800">{category.title}</h3>
                  </div>
                  <motion.span
                    animate={{ rotate: activeCategoryId === category.id ? 180 : 0 }}
                    transition={{ duration: 0.3 }}
                    className="text-xl text-gray-500" // Adjusted size and color
                  >
                    ▼
                  </motion.span>
                </button>
                <AnimatePresence>
                  {activeCategoryId === category.id && (
                    <motion.div
                      initial={{ height: 0, opacity: 0 }}
                      animate={{ height: 'auto', opacity: 1 }}
                      exit={{ height: 0, opacity: 0 }}
                      transition={{ duration: 0.3, ease: "easeInOut" }} // Smoother transition
                      className="overflow-hidden border-t border-gray-200" // Added border top
                    >
                      <div className="p-6 bg-white"> {/* Ensured background for content */}
                         <ul className="space-y-2 text-gray-600"> {/* List styling */}
                           {category.services.map((service, index) => (
                             // Render top-level items and handle nested structure recursively if needed
                             // For now, directly render, assuming only one level of nesting in 'options'
                             <React.Fragment key={index}>
                               {service.options ? (
                                 // Handle items with options (like Brushing, Waxing)
                                 <li className="mb-2">
                                    <span className="font-medium text-gray-700">{service.name}:</span>
                                    <ul className="list-disc list-inside ml-6 mt-1 text-sm">
                                        {service.options.map((option, optIndex) => (
                                            <li key={optIndex} className="flex justify-between">
                                                <span>{option.name}</span>
                                                {option.price && <span className="font-medium">{option.price}</span>}
                                            </li>
                                        ))}
                                    </ul>
                                 </li>
                               ) : (
                                 // Render simple items
                                 <li className="flex justify-between items-center">
                                   <span>{service.name}</span>
                                   {service.price && <span className="font-medium text-gray-700">{service.price}</span>}
                                  </li>
                               )}
                             </React.Fragment>
                           ))}
                         </ul>
                      </div>
                    </motion.div>
                  )}
                </AnimatePresence>
              </motion.div>
            ))}
          </div>
{/*           <div className='hidden xl:flex h-full justify-center items-center w-1/2'>
            <motion.div
              className="p-6 pb-20 shadow-md cursor-pointer bg-white h-full w-2/3 xl:w-full"
              variants={imageVariants} // Animate each thumbnail wrapper
              whileHover={{ scale: 1.05 }}
              transition={{ type: "spring", stiffness: 300 }}
            >
              <AnimatePresence mode="wait"> 
                <motion.img
                  key={activeCategoryId} // Key change triggers animation
                  src={servicesData.find((service) => service.id === activeCategoryId)?.image || servicesData[0].image} // Fallback to first image
                  alt={`Service thumbnail`}
                  className="w-full h-full object-cover "
                  initial={{ opacity: 0, x: -50 }} // Initial state (entering)
                  animate={{ opacity: 1, x: 0 }} // Animate to (entering)
                  exit={{ opacity: 0, x: 50 }} // Exit state
                  transition={{ duration: 0.5, ease: 'easeInOut' }} // Transition config
                />
              </AnimatePresence>
            </motion.div>
          </div> */}
        </div>
      </div>
    </motion.section>
  );
};

export default ServicesPage; 